import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import useStyles from "components/User/CreateUser/CreateUserStyle";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import userActions from "components/User/actions";
import { UILabels, UserRole, UserRoleText, USER_PROP } from "../constants";
import { FormControl, Grid, useMediaQuery } from "@material-ui/core";
import { checkEmailValid, checkFieldValid } from "../Validation";
import { useSelector } from "react-redux";

const CreateUserForm = () => {
  const classes = useStyles();
  const { createUser, closeCreateDialog, setCreateUser } = userActions();
  const { createUserDialog } = useSelector((state) => state.user);

  const textfields = [
    USER_PROP.EMAIL,
    USER_PROP.FNAME,
    USER_PROP.LNAME,
    USER_PROP.PASSWORD,
  ];

  const [fieldChecked, setFieldChecked] = useState({
    ...Object.fromEntries(textfields.map((each) => [[each], false])),
  });
  const [isFormValid, setIsFormValid] = useState(true);

  const submitForm = (event) => {
    event.preventDefault();
    createUser(createUserDialog, closeCreateDialog);
  };

  useEffect(() => {
    checkFormValidity();
  });

  const checkFormValidity = () => {
    let checkFields =
      checkEmailValid(createUserDialog[USER_PROP.EMAIL]) &&
      !!createUserDialog[USER_PROP.FNAME] &&
      !!createUserDialog[USER_PROP.LNAME];

    setIsFormValid(checkFields);
  };
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <div className={classes.content}>
      <form noValidate onSubmit={submitForm}>
        {textfields.map((value, index) => {
          return (
            <TextField
              variant="outlined"
              margin="normal"
              error={
                fieldChecked[value] &&
                !checkFieldValid(value, createUserDialog[value])
              }
              required
              fullWidth
              key={index}
              size="small"
              id={value}
              label={UILabels[value]}
              type={value ? value : ""}
              name={value}
              value={createUserDialog[value]}
              onClick={() => {
                setFieldChecked({
                  ...fieldChecked,
                  [value]: true,
                });
              }}
              onChange={(e) =>
                setCreateUser({
                  ...createUserDialog,
                  [value]: e.target.value,
                })
              }
            />
          );
        })}
        <FormControl
          className={classes.roleControl}
          fullWidth
          variant="outlined"
          size="small"
        >
          <InputLabel>{UILabels[USER_PROP.ROLE]}</InputLabel>
          <Select
            required
            label={UILabels[USER_PROP.ROLE]}
            onChange={(e) =>
              setCreateUser({
                ...createUserDialog,
                [USER_PROP.ROLE]: e.target.value,
              })
            }
            value={createUserDialog[USER_PROP.ROLE]}
          >
            {Object.keys(UserRole).map((x, index) => {
              return (
                <MenuItem value={UserRole[x]} key={index}>
                  {UserRoleText[x]}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        <Grid container justify="flex-end">
          <Button
            type="submit"
            disabled={!isFormValid}
            variant="contained"
            color="primary"
            className={classes.action}
            fullWidth={!matches}
          >
            Create
          </Button>
        </Grid>
      </form>
    </div>
  );
};

export default CreateUserForm;
